import React, { createContext, useState, useContext, useCallback } from 'react';
import { noop } from '@moda/portal-stanchions';

type CheckoutFormState = 'open' | 'closed';

type CheckoutFormStates = {
  shippingAddress: CheckoutFormState;
  shippingMethod: CheckoutFormState;
  paymentMethod: CheckoutFormState;
};

const DEFAULT_FORM_STATES: CheckoutFormStates = {
  shippingAddress: 'closed',
  shippingMethod: 'closed',
  paymentMethod: 'closed'
};

type CheckoutFormStatesContextType = {
  formStates: CheckoutFormStates;
  setFormState: (form: keyof CheckoutFormStates, state: CheckoutFormState) => void;
  sameDayDeliveryNotes: string;
  setSameDayDeliveryNotes: (notes: string) => void;
};

const CheckoutFormStatesContext = createContext<CheckoutFormStatesContextType>({
  formStates: DEFAULT_FORM_STATES,
  setFormState: noop,
  sameDayDeliveryNotes: '',
  setSameDayDeliveryNotes: noop
});

export const CheckoutFormStatesProvider: React.FC<{ children?: React.ReactNode }> = ({
  children
}) => {
  const [formStates, setFormStates] = useState(DEFAULT_FORM_STATES);
  const [sameDayDeliveryNotes, setSameDayDeliveryNotes] = useState('');

  const setFormState = useCallback(
    (form: keyof CheckoutFormStates, state: CheckoutFormState) =>
      setFormStates(prevFormStates => ({ ...prevFormStates, [form]: state })),
    [setFormStates]
  );

  return (
    <CheckoutFormStatesContext.Provider
      value={{ formStates, setFormState, sameDayDeliveryNotes, setSameDayDeliveryNotes }}
    >
      {children}
    </CheckoutFormStatesContext.Provider>
  );
};

export const useCheckoutFormStates = () => useContext(CheckoutFormStatesContext);
